import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  mergeClasses,
  makeStyles
} from "@fluentui/react-components";
import { CloseButton } from "../input/CloseButton";

const useStyles = makeStyles({
  dialog: {
    maxWidth: "480px",
    overflowY: "auto",
    maxHeight: "80vh"
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "var(--Font-size-100, 10px)"
  },
  dialogContent: {
    overflow: "unset"
  },
  dialogBody: {
    maxHeight: "unset"
  },
  dialogActions: {
    "& .fui-Button": {
      whiteSpace: "nowrap"
    }
  }
});

export function Modal({
  id = "",
  title,
  titleNode,
  beforeTitle,
  afterTitle,
  children,
  contentClassName,
  headerClassName,
  afterTitleClassName,
  open = true,
  onOpenChange,
  onClose,
  actions
}) {
  const styles = useStyles();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogSurface id={id} className={styles.dialog}>
        <DialogBody className={styles.dialogBody}>
          {(title || beforeTitle || afterTitle) && (
            <DialogTitle
              action={onClose ? <CloseButton onClick={onClose} /> : null}
              className={mergeClasses(styles.dialogTitle, headerClassName)}
            >
              {titleNode ? titleNode : <>{title}</>}
              {beforeTitle && <div className={styles.beforeTitle}>{beforeTitle}</div>}
              {afterTitle && <div className={mergeClasses(styles.afterTitle, afterTitleClassName)}>{afterTitle}</div>}
            </DialogTitle>
          )}
          <DialogContent className={mergeClasses(styles.dialogContent, contentClassName)}>{children}</DialogContent>
          {actions && <DialogActions className={styles.dialogActions}>{actions}</DialogActions>}
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

Modal.propTypes = {
  id: PropTypes.string,
  title: PropTypes.node,
  titleNode: PropTypes.node,
  beforeTitle: PropTypes.node,
  afterTitle: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  disableFullscreen: PropTypes.bool,
  transparent: PropTypes.bool,
  headerClassName: PropTypes.string,
  afterTitleClassName: PropTypes.string,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  onClose: PropTypes.func,
  actions: PropTypes.node
};
